module.exports = __webpack_public_path__ + "img/title-img.2169b87c.jpg";